export interface PrizmOverflowItem<T = any> {
  html: HTMLElement;
}
export interface PrizmOverflowReserveSpace {
  x?: number;
  y?: number;
}
